import { Form, Input, Modal } from 'antd'
import { WasteHandoverRegistrationModel } from 'models/WasteHandoverRegistration';
import { SearchForm, SearchItem } from 'pages/Components/SearchBox'
import React from 'react'
import { IoIosInformationCircle } from "react-icons/io";
import CustomButton from 'base/ui/components/Button';
import { useTranslation } from 'react-i18next';

export type CancelConfirmProps = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    dataCancel?: Pick<WasteHandoverRegistrationModel, 'wasteHandoverRegistrationCode' | "wasteHandoverRegistrationId">
    onFormSubmit: (value: Promise<{ cancelReason: string; wasteHandoverRegistrationId: string }>) => void
    loading: boolean
}

const CancelConfirm: React.FC<CancelConfirmProps> = (props) => {
    const { open, onOpenChange, dataCancel, onFormSubmit, loading } = props
    const { t } = useTranslation();

    const [cancelForm] = Form.useForm()

    return (
        <Modal
            destroyOnClose
            open={open}
            onCancel={() => {
                cancelForm.resetFields()
                onOpenChange(false)
            }}
            footer={false}
            title={<span className='flex items-center gap-2'>
                <IoIosInformationCircle className='text-3xl text-orange-500' />
                <p>{t('waste-handover-plan-register.cancel-confirm-title', { code: dataCancel?.wasteHandoverRegistrationCode })}</p>
            </span>}
        >
            <h2>{t('waste-handover-plan-register.cancel-confirm-message', { code: dataCancel?.wasteHandoverRegistrationCode })}</h2>
            <SearchForm
                column='col-1'
                form={cancelForm}
            >
                <SearchItem
                    name="cancelReason"
                    rules={[{ required: true, message: t('waste-handover-plan-register.cancel-reason-required') }]}
                    label={<span className="font-semibold text-default">{t('waste-handover-plan-register.cancel-reason')}</span>}
                    labelCol={{ span: 24 }}
                >
                    <Input.TextArea placeholder={t('waste-handover-plan-register.cancel-reason-placeholder')} style={{ borderRadius: 2 }} rows={3} />
                </SearchItem>
                <div className='flex justify-end gap-3 pt-3'>
                    <CustomButton loading={loading} onClick={() => {
                        cancelForm.resetFields()
                        onOpenChange(false)
                    }} htmlType='button'>
                        {t('btn.cancel')}
                    </CustomButton>
                    <CustomButton loading={loading} htmlType='button'
                        onClick={() => {
                            cancelForm.validateFields().then((value) => {
                                onFormSubmit(Promise.resolve({
                                    ...value,
                                    wasteHandoverRegistrationId: dataCancel?.wasteHandoverRegistrationId || '',
                                }))
                            }).catch((error) => { onFormSubmit(Promise.reject(error)) })
                        }}
                        type='primary' color='#ef4444'>
                        {t('waste-handover-plan-register.confirm-cancel')}
                    </CustomButton>
                </div>
            </SearchForm>
        </Modal>
    )
}

export default CancelConfirm

